<template>
  <delete-box
    class="pad-top"
    text="Are you sure you want to delete this asset?"
    loaderText="Deleting Asset"
    :showLoader="showLoader">
      <a v-on:click="submit" class="add button level-item">
        <i class="far fa-save"></i>
        Delete Asset
      </a>
  </delete-box>
</template>

<script>
import DeleteBox from '@/components/DeleteBox.vue';

export default {
  name: 'AssetDelete',
  components: { DeleteBox },
  props: {
    asset: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showLoader: false,
    };
  },
  methods: {
    async submit() {
      this.showLoader = true;
      const asset = await this.$store.dispatch('primary/deleteAsset', { uuid: this.asset.uuid });
      this.showLoader = false;
      if (asset) {
        this.$router.push({ name: 'assets.index' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.pad-top {
  margin-top: $content-padding;
}
</style>
